const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPpt(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Icon/PDF/36pt"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 25634"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13614",
    d: "M160.172 13a2 2 0 0 1 1.414.586l7.828 7.828a2 2 0 0 1 .586 1.414V40a3.009 3.009 0 0 1-3 3h-18.015A3 3 0 0 1 146 40V16a3.009 3.009 0 0 1 3-3zm.828 1.75v5.75a1.5 1.5 0 0 0 1.5 1.5h5.75z",
    transform: "translate(-140 -10)",
    style: {
      fill: "#c03a1b",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13615",
    d: "M154.466 36V25.568h3.584a7.079 7.079 0 0 1 1.616.176 3.464 3.464 0 0 1 1.312.56 2.622 2.622 0 0 1 .88 1.04 3.379 3.379 0 0 1 .336 1.584 3.5 3.5 0 0 1-.336 1.584 2.986 2.986 0 0 1-.88 1.1 3.775 3.775 0 0 1-1.3.64 5.735 5.735 0 0 1-1.568.208h-1.3V36zm2.352-5.408h1.152q1.92 0 1.92-1.664a1.272 1.272 0 0 0-.512-1.152 2.684 2.684 0 0 0-1.472-.336h-1.088z",
    transform: "translate(-140 -10)",
    style: {
      fill: "#fff"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPpt);
export default __webpack_public_path__ + "static/media/PPT.c0b483a63b072a39191b75ef07b0a37b.svg";
export { ForwardRef as ReactComponent };